/* global window */
import {
  takeLatest,
} from 'redux-saga/effects';
import { replace as routerReplace } from 'react-router-redux';
import {
  contracting as contractingApis,
} from '../../../../api';
import { apiSaga } from '../../../../sagas';
import * as cnt from '../../__storeFiles__/constants';

function* removeDraftOutOfQueue({ type, payload }) {
  yield* apiSaga(
    type,
    contractingApis.removeDraftOutOfQueue,
    [{
      templateId: payload.draftId,
      sourceId: payload.draftId,
      refreshSection: payload.refreshSection,
    }],
  );
}

function* addDraftToQueue({ type, payload }) {
  yield* apiSaga(
    type,
    contractingApis.addDraftToQueue,
    [{
      templateId: payload.draftId,
      sourceId: payload.draftId,
      source: 'draft',
      message: payload.message,
    }],
  );
}

function* sendUpdatesFromQueue({ type, payload }) {
  yield* apiSaga(
    type,
    contractingApis.supplierSendUpdates,
    [{ templateIds: payload.templateIds, subject: payload.subject }]
  );
}

export default [
  takeLatest(cnt.REMOVE_DRAFT_FROM_QUEUE, removeDraftOutOfQueue),
  takeLatest(cnt.ADD_DRAFT_TO_QUEUE, addDraftToQueue),
  takeLatest(cnt.SEND_UPDATES_FROM_QUEUE, sendUpdatesFromQueue),
];



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-updates-queue/__storeFiles__/saga.js